import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, spacing, typography, borderRadius } = useTheme();

  return {
    locSuggesst: css`
      position: 'relative';
      width: 100%;
    `,
    magnify: css`
      margin-top: 0.5rem;
      color: ${colors.placeholder_black2};
    `,
    closeBtn: css`
      cursor: pointer;
      svg {
        margin-top: 0.5rem;
        &:hover {
          path {
            stroke: ${colors.buttonBlue};
          }
        }
      }
      &:focus-visible {
        margin-left: 5px;
        outline: 2px solid ${colors.skip_yellow};
        border: 2px solid ${colors.border_black};
        padding: 0px 6.5px 2px;
        border-radius: 50px;
        svg {
          path {
            stroke: ${colors.border_black};
          }
        }
      }
    `,
    searchDropdownList: css`
      list-style-type: none;
      padding: 0.5rem;
      position: absolute;
      background: ${colors.white};
      border: 1px solid #ccc;
      border-radius: 0.5rem;
      width: 100%;
      z-index: 1;
      cursor: pointer;
      overflow-y: auto;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
      margin-top: 10px;
      top: 100%;
      left: 0;
    `,
    listItems: isActive => css`
      padding: 8px;
      background-color: ${isActive
        ? colors.pale_blue
        : colors.white};
      cursor: pointer;
      list-style-type: none;
      gap: 0.75rem;
      border-radius: 0.25rem;
      &:hover {
        background-color: ${colors.pale_blue};
      }
      /* icon default / active color */
      svg path,
      svg circle {
        stroke: ${isActive ? colors.surfaceBlue : colors.buttonRed};
        fill: ${isActive ? colors.surfaceBlue : colors.buttonRed};
        transition: stroke 0.12s ease, fill 0.12s ease;
      }

      &:hover {
        background-color: ${colors.pale_blue};
        svg path,
        svg circle {
          stroke: ${colors.surfaceBlue};
          fill: ${colors.surfaceBlue};
        }
      }

      &:focus-visible {
        outline: none;
        > div:first-of-type > div:nth-of-type(2) > div:nth-of-type(1) {
          background-color: ${colors.skip_yellow};
          text-decoration: underline;
          border-bottom: 2px solid ${colors.border_black};
        }
      }
    `,
    listItemContent: css`
      display: flex;
      flex-direction: row;
      align-items: center;
    `,

    primaryText: css`
      font-family: 'FS Dillon';
      font-weight: 700;
      font-size: 1rem;
      line-height: 1.25rem;
      letter-spacing: 2%;
      color: ${colors.placeholder_black2};
    `,

    secondaryText: css`
      font-family: 'FS Dillon';
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.25rem;
      letter-spacing: 2%;
      color: ${colors.divider_gray};
    `,

    locationSvg: css`
      width: 1.5rem;
      height: 1.5rem;
      padding-left: 0.5rem;
      margin-right: 0.75rem;
      margin-top: -1rem;
      svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      /* ensure the icon inherits color rules from listItems */
      svg path,
      svg circle {
        transition: stroke 0.12s ease, fill 0.12s ease;
      }
    `,
    inputWrapper: (magnifierIconVariant, isFilter, currentValue, locationHasError) => css`
      display: flex;
      color: ${(magnifierIconVariant === 'light' && !locationHasError ) ? colors.white : colors.black};
      svg {
        color: inherit;
        transition: color 0.2s ease;
        margin-top: 0.5rem;
      }
      &:hover {
        color: ${colors.black};
      }
      input {
        background-color: transparent !important;
        color: inherit;
        font-weight: ${ magnifierIconVariant === 'light' && !locationHasError ? 700 : 400 } !important;
      }
      input::placeholder {
        color:inherit;
      }
      &:hover {
        color: ${colors.navy};
      }
      border: 1px solid ${locationHasError ? colors.buttonRed : colors.lightGrey};
      border: solid
      ${isFilter
        ? `${locationHasError ? colors.buttonRed : colors.border_blue} 2px`
        : `${colors.lightGrey} 1px`};
      border-radius: ${borderRadius.m};
      ${locationHasError &&
      css`
        border-radius: ${borderRadius.m} ${borderRadius.m} ${borderRadius.xs}
          ${borderRadius.xs};
      `}
      align-items: center;
      padding: 0 ${isFilter ? '10px' : spacing.m};
      width: 100%;
      position: relative;
      box-sizing: border-box;
      &.keyboard-focus {
        border: 2px solid ${colors.border_black} !important;
        outline: 2px solid ${colors.skip_yellow} !important;
        color: ${colors.black};
        input {
          color: ${colors.black};
        }
        .closeBtn svg path {
          stroke: ${colors.black};
        }
        .magnify {
          color: ${colors.black};
        }
      },
      input {
        background-color: ${locationHasError
          ? colors.pale_red
          : 'transparent'} !important;
      }
      ${locationHasError &&
      css`
        background-color: ${colors.pale_red};
      `}
      ${locationHasError &&
      css`
        svg path {
          fill: ${locationHasError ? colors.red : colors.darkGrey};
        }
      `}

      &:hover {
        border-color: ${locationHasError
          ? colors.buttonRed
          : colors.navy} !important;
        background-color: ${isFilter
          ? `${locationHasError ? colors.pale_red : colors.pale_blue}`
          : `${colors.white}`};
        input {
          background-color: ${isFilter
            ? `${locationHasError ? colors.pale_red : colors.pale_blue}`
            : `${colors.white}`} !important;
        }
      }

      &:focus-within {
        border-color: ${locationHasError
          ? colors.buttonRed
          : colors.navy};
        background-color: ${isFilter
          ? `${locationHasError ? colors.pale_red : colors.pale_blue}`
          : `${colors.white}`} !important;
        input {
          background-color: ${isFilter
            ? `${locationHasError ? colors.pale_red : colors.pale_blue}`
            : `${colors.black}`} !important;
        }
        color: black;
      }

      ${locationHasError &&
      css`
        svg path {
          fill: ${locationHasError ? colors.red : colors.darkGrey};
        }
      `}
    `,

    /* ... (magnify styles omitted for brevity) ... */
    input: (isFilter, locationHasError) => css`
      ${typography.base};
      appearance: none;
      background-color: ${colors.white};
      border: none;
      font: inherit;
      color: ${colors.navy};
      line-height: inherit;
      padding: ${spacing.s};
      transition-duration: 0.2s;
      transition-property: border-color;
      width: 100%;
      text-align: center;
      font-weight: 400 !important;
      font-size: 18px !important;

      &:hover,
      &:focus {
        border-color: ${colors.navy};
        outline: none; /* Remove outline from the input itself */
      }
      &:focus::placeholder {
        color: transparent;
        opacity: 0;
      }

      &:hover {
        background-color: ${isFilter
          ? `${locationHasError ? colors.buttonRed : colors.pale_blue}`
          : `${colors.white}`} !important;
      }

      /* Chrome/Opera/Safari */
      &::-webkit-input-placeholder {
        color: ${colors.navy};
      }

      /* firefox */
      &::-moz-placeholder {
        color: ${colors.navy};
        opacity: 1;
      }

      /* IE 10+ */
      :-ms-input-placeholder {
        color: ${colors.navy};
      }

      /* --- FIX: Remove :focus-visible styles from the input itself --- */
      /* We apply these styles to the parent wrapper using :has() instead */
      &:focus-visible {
        outline: none;
        border: none;
      }
    `,
  };
};
